import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import LargeItemStatus from "../../../../../../common/components/large_item_status";

type Props = {
  onActionEdit: (idGestaoEpi: number | null, openState: boolean) => void;
  onActionDelete: (idGestaoEpi: number | null, openState: boolean) => void;
};

export const GenerateGestapEpiColumns = ({
  onActionEdit,
  onActionDelete,
}: Props): GridColDef[] => {

  //#region  Status
   const computeItemStatusTitle = (tipo: boolean) => {
    switch (tipo) {
      case false:
        return "Inativo";
      case true:
        return "Ativo";
      default:
        return "?";
    }
  };
  const computeItemStatusColor = (tipo: boolean) => {
    switch (tipo) {
      case false:
        return "red";
      default:
        return "green";
    }
  };

  //#endregion
  return [
    {
      field: "idGestaoEpi",
      filterable: false,
      headerName: "Código",
      width: 80, 
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "ativo",
      filterable: false,
      headerName: "Status",
      width: 140, 
      sortable: false,
      renderCell: (params) => {
        return (
          <div className="w-full h-full flex justify-center items-center">
            <LargeItemStatus
              title={computeItemStatusTitle(params.value)}
              color={computeItemStatusColor(params.value)}
              description=""
            />
          </div>
        );
      }
    },
    {
      field: "nomeEpi",
      filterable: false,
      headerName: "Nome do EPI",
      minWidth: 150,
      flex: 1, 
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "especificacao",
      filterable: false,
      headerName:"Tipo/Numeração",
      minWidth: 150,
      flex: 1, 
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex items-center text-center text-xs py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: 'acoes',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 90, 
      resizable: false,
      valueGetter: (_, row) => ([row['idGestaoEpi']]),
      renderCell: ({ value: [idGestaoEpi] }) => {
        return (
          <div className="w-full h-full flex items-center justify-center gap-0">
            <IconButton
              onClick={e => onActionEdit(idGestaoEpi, true)}>
              <DynamicIcon
                nameIcon="EditRounded"
                size={20}
                className="dark:text-white text-primary-green"
              />
            </IconButton>

            <IconButton
              onClick={() => onActionDelete(idGestaoEpi, true)}>
              <DynamicIcon
                nameIcon="DeleteForeverRounded"
                size={20}
                className='text-red-500'
              />
            </IconButton>
          </div>
        );
      }
    }
  ];
}